import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { RootState } from 'store/types'

// селектор с типизацией
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
